import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

const useInactivityLogout = (timeoutMs = 10 * 60 * 1000) => {
  const navigate = useNavigate();
  const timer = useRef(null);

  useEffect(() => {
    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        localStorage.removeItem('user');
        navigate('/login', { replace: true });
      }, timeoutMs);
    };

    reset();
    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));

    return () => {
      clearTimeout(timer.current);
      EVENTS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [navigate, timeoutMs]);
};

export default useInactivityLogout;
